// @flow

export { KenyanTermsForInternationalTransfer } from './kenyan-terms-for-international-transfer';
